import { render, staticRenderFns } from "./ArchivePc.vue?vue&type=template&id=b1bcf188&scoped=true&"
import script from "./ArchivePc.vue?vue&type=script&lang=js&"
export * from "./ArchivePc.vue?vue&type=script&lang=js&"
import style0 from "./ArchivePc.vue?vue&type=style&index=0&id=b1bcf188&prod&lang=css&"
import style1 from "./ArchivePc.vue?vue&type=style&index=1&id=b1bcf188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bcf188",
  null
  
)

export default component.exports